import { Link, Navbar, NavRight } from "framework7-react";

const PopupNavbar = ({ title, children }) => (
  <Navbar title={title}>
    {children}
    <NavRight>
      <Link iconOnly popupClose aria-label="Schließen">
        <i className="icon icon-close" />
      </Link>
    </NavRight>
  </Navbar>
);

// <Page> renders a child outside its scrolling page-content only for this name.
PopupNavbar.displayName = "f7-navbar";

export default PopupNavbar;
